const INFO = {
	main: {
		title: "Juan P. Nieblas",
		name: "Juan P. Nieblas",
		email: "juan@nieblas.dev",
		logo: "../logo.png",
	},

	socials: {
		github: "https://github.com/juanykty",
		linkedin: "https://www.linkedin.com/in/juanykty/",
	},

	homepage: {
		title: "Full-stack developer / technology consultant.",
		description:
			`I possess over a decade of experience as a developer specializing in Node.js and Python. My expertise lies in crafting scalable, secure, and dependable web applications, employing a range of frameworks and technologies such Express, Next, Angular, React, Flask, Django, FastAPI and Lavarel. I thrive on tackling intricate challenges and expanding my skill set. My dedication to producing top-notch code adhering to best practices and industry norms is unwavering. Continuously seeking fresh challenges and avenues for professional growth drives my passion for development.`,
	},

	about: {
		title: "I’m Juan Nieblas. I live in Sonora, MX. And I love the technology.",
		description:
			`Throughout my career, I’ve had the opportunity to contribute to a variety of projects across different industries. These experiences have allowed me to grow both technically and creatively, constantly challenging myself to deliver quality results. Each project has helped refine my skills and deepen my understanding of how to approach problems from multiple angles.
			I’ve worked independently with organizations such as Inmobiliaria Yuuma, Mundo Minero, Allegro Response Teleservices, Eleven Technologies, and CatOverflow. These roles allowed me to take initiative, manage my own time and priorities, and adapt quickly to different business needs. I’ve also collaborated with larger companies like Officemax and Rivka Development, where I learned to operate within more structured teams and systems.
			One of the key lessons I've learned is the value of collaboration. Working with others not only enhances the outcome of a project but also broadens your own perspective. Whether I’m leading a task or contributing as part of a group, I believe that clear communication and mutual respect are fundamental to successful teamwork.
			I'm always eager to learn and welcome new challenges. I believe that constructive feedback and diverse viewpoints are essential for continuous improvement. With every new experience, I aim to grow as both a professional and a collaborator, staying open to innovation and evolving ideas.`,
	},

	articles: {
		title: "I share my passion for redefining what's possible and motivating the innovators of tomorrow.",
		description: "In-depth reflections on coding, leadership, product design, and beyond."

	},

	projects: [
		{
			title: "GambitOdds",
			description:
				"Bets Platform maded with React, Express, Docker,PostgreSQL and mongoDB for bets real time results using Oddsjam APIs.",
			logo: "GoLogo.svg",
			linkText: "View Project",
			link: "https://gambitodds.com",
		},
		{
			title: "Ratespot.io",
			description:
				"Real Estate Platform maded with React, Flask, Docker and PostgreSQL and Amazon Glue.",
			logo: "ratespot.webp",
			linkText: "View Project",
			link: "https://ratespot.io",
		},
		{
			title: "Inmobiliaria Yuuma",
			description:
				"Real Estate CMS maded with Angular, Express, EasyBroker and MySQL",
			logo: "logo_yuuma.png",
			linkText: "View Project",
			link: "https://inmobiliariayuuma.com",
		},

		{
			title: "Mundo Minero",
			description:
				"Online Magazine. maded with React, Next, Node.js and MySQL using S3 for file storage.",
			logo: "mm.jpg",
			linkText: "View Project",
			link: "https://mundominero.mx",
		},

		{
			title: "Allegro Response Teleservices",
			description:
				"Brand Website. maded with React, Laravel and MySQL.",
			logo: "allegro.png",
			linkText: "View Project",
			link: "https://allegroresponse.com",
		},

		{
			title: "Eleven Tecnologies",
			description:
				"software consulting landing page maded with React, Next, Node.js and Twilio APIs.",
			logo: "eleven.jpg",
			linkText: "View Project",
			link: "https://eleven-technologies.com",
		},

		{
			title: "CatOverflow",
			description:
				"Blog maded with PHP, Laravel and MySQL.",
			logo: "catoverflow.png",
			linkText: "View Project",
			link: "https://catoverflow.com.mx",
		},
	],
};

export default INFO;
